module.exports = __webpack_public_path__ + "img/calendar-sidemenu.8e92c081.svg";